@if (show) {
  <div class="spinner" [ngClass]="{'align-inner-right':floatRight === true, 'align-inner-left':floatLeft === true}">
    <!-- <div class="spinner-circle"></div> -->
    {{text}}
    <div class="spinner-three-bounce">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
}
